module.exports = __webpack_public_path__ + "static/img/28-3.c01a7a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/28-3.jpg
// module id = kHzx
// module chunks = 0